module.exports = __webpack_public_path__ + "img/icon-faq-orders.a2af20f7.svg";